import React from 'react';
import { Modal, message, Dropdown, Button, type MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import * as atoms from '@src/components/user-management/store/atom';
import type * as Types from '../../../types';
import { useSetAtom } from 'jotai';

interface Props {
  userProfile: Types.UserProfileInfo;
}
export const Operations = ({ userProfile }: Props) => {
  const [modal, contextHolder] = Modal.useModal();
  const setUserEdit = useSetAtom(atoms.userToEditAtom);
  const setUsersToRevoke = useSetAtom(atoms.usersToRevokeAtom);

  const handleEdit = async () => {
    setUserEdit(userProfile);
  };

  const handleRevoke = async () => {
    setUsersToRevoke([userProfile]);
  };

  const dropdownMenuItems = [
    {
      key: 'edit',
      label: 'Edit Role',
    },
    {
      key: 'delete',
      label: 'Revoke Access',
    },
  ];

  return (
    <>
      {contextHolder}
      <Dropdown
        className="operations"
        placement="bottomRight"
        trigger={['click']}
        menu={{
          items: dropdownMenuItems as MenuProps['items'],
          onClick: ({ key }) => {
            if (key === 'edit') {
              return handleEdit();
            }
            if (key === 'delete') {
              return handleRevoke();
            }
          },
        }}
      >
        <Button type="text" icon={<MoreOutlined />} style={{ fontSize: 16 }} />
      </Dropdown>
    </>
  );
};
